import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const MinimizeBottomright = ({
  size,
  type,
  theme,
  className,
  dataTestId = "minimize-bottomright",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2.454a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2H2Zm-.667 2c0-.368.299-.667.667-.667h12c.368 0 .667.299.667.667v3.333H10a2 2 0 0 0-2 2v3.333H2a.667.667 0 0 1-.667-.666v-8Zm8 8.667H14a.667.667 0 0 0 .667-.667V9.12H10a.667.667 0 0 0-.667.666v3.333Z"
    />
  </SVGIcon>
);
